"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var IntegrationsListController_1 = __importDefault(require("./IntegrationsListController"));
var Telemetry_1 = __importDefault(require("Settings/Telemetry"));
var IntegrationUI = (function () {
    function IntegrationUI(make, createUi, controller, userHasAccess) {
        var _this = this;
        this.controller = controller;
        this.userHasAccess = userHasAccess;
        this.openIntegrationSettings = this.openIntegrationSettings.bind(this);
        var integrationsListController = make(IntegrationsListController_1.default, {
            openIntegrationSettings: this.openIntegrationSettings,
        });
        this.settingsTelemetry = make(Telemetry_1.default);
        this.ui = createUi(require("./Integrations.html"), {
            showIntegrationList: true,
            integrationList: integrationsListController.ui,
            goBack: function () {
                _this.ui.showIntegrationList = true;
                controller.goToIntegrationsList();
            },
        });
    }
    IntegrationUI.prototype.openIntegrationSettings = function (integration) {
        if (!this.userHasAccess) {
            return;
        }
        this.ui.showIntegrationList = false;
        this.ui.currentIntegration = this.controller.getIntegrationSettingsUI(integration);
        if (this.ui.currentIntegration) {
            var integrationName = (integration === null || integration === void 0 ? void 0 : integration.internalName) || integration || "";
            var urlSafeName = (integration === null || integration === void 0 ? void 0 : integration.urlSafeName) || integration || "";
            this.settingsTelemetry.trackIntegrationsSettingsSubsectionViewed(integrationName);
            this.controller.goToIntegration(urlSafeName);
        }
    };
    return IntegrationUI;
}());
exports.default = IntegrationUI;
